import { render, staticRenderFns } from "./authority-setting.pug?vue&type=template&id=b0f60bba&lang=pug&"
import script from "./authority-setting.ts?vue&type=script&lang=ts&"
export * from "./authority-setting.ts?vue&type=script&lang=ts&"
import style0 from "./authority-setting.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports